import styled from "styled-components";

const TextareaWrap = styled.div`
	padding: 10px 0;
	> textarea {
		min-height: 200px;
	}
`;

const ButtonBlock = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 30px;

	> button + button {
		margin-left: 10px;
	}
`;

const BulletList = styled.ul`
	margin-top: 15px;
`;

const SelectWrap = styled.div`
	position: relative;
	width: 100%;
	height: 45px;
	ul {
		left: -1px;
		width: 510px;
	}
`;

export {TextareaWrap, ButtonBlock, BulletList, SelectWrap};
